import { graphql } from '~/lib/graphql'

export const MemberCards = graphql(`
  fragment MemberCards on ReserveInfoMember {
    cards {
      cardId
      maskedNumber
      goodThru
      holderName
      brand
      isPrimary
    }
  }
`)
